module.exports = __webpack_public_path__ + "img/2023big20.aeb39466.png";